import type { TerpeneFlavorEnum } from '@iheartjane/menu';
import { TERPENE_FLAVOR_ICONS } from '@iheartjane/menu';
import { Flex, Typography } from '@iheartjane/reefer';

import styles from './flavorCard.module.css';

interface FlavorCardProps {
  flavor: TerpeneFlavorEnum;
}

export const FlavorCard = ({ flavor }: FlavorCardProps) => {
  const Icon = TERPENE_FLAVOR_ICONS[flavor];

  return (
    <Flex className={styles['flavorCard']}>
      <Icon size="md" />
      <Typography>
        {flavor.charAt(0).toUpperCase() + flavor.slice(1)}
      </Typography>
    </Flex>
  );
};
